import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { useEditor } from '../../../../components/Canvas';
import Delete from '../Icons/Delete';
import ArrowUp from '../Icons/ArrowUp';
import ArrowDown from '../Icons/ArrowDown';

function BackFrameButtons() {
  const editor = useEditor();

  const removeFrame = () => {
    editor.handlers.frameHandler.remove('backSide');
    editor.handlers.scrollbarHandler.setScrollToTop();
    editor.handlers.scrollbarHandler.updateScrollPosition();
  };

  const scrollToTop = () => {
    editor.handlers.scrollbarHandler.jumpUp();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        position: 'absolute',
        fontWeight: 'bold',
        alignItems: 'center',
      }}
      id="back-buttons"
      onWheel={event => {
        editor.handlers.scrollbarHandler.onMouseWheel(event);
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '90px',
          justifyContent: 'space-between',
        }}
      >
        <Tooltip hasArrow label="Move up" mt="10px">
          <IconButton
            borderColor="#A7A7A7"
            variant="ghost"
            size="sm"
            w="28px"
            h="28px"
            icon={<ArrowUp size={16} />}
            onClick={() => {
              scrollToTop();
            }}
          />
        </Tooltip>
        <Tooltip hasArrow label="Move down" mt="10px">
          <IconButton
            cursor="not-allowed"
            borderColor="#A7A7A7"
            variant="ghost"
            size="sm"
            w="28px"
            h="28px"
            _hover={{ backgroundColor: 'none' }}
            _active={{ backgroundColor: 'none' }}
            icon={<ArrowDown size={16} style={{ fill: '#A0AEC0' }} />}
          />
        </Tooltip>
        <IconButton
          cursor="pointer"
          borderColor="#A7A7A7"
          variant="ghost"
          size="sm"
          w="28px"
          h="28px"
          icon={<Delete size={20} />}
          onClick={() => {
            removeFrame();
          }}
        />
      </Box>
    </Box>
  );
}

export default BackFrameButtons;
